// Set Arabic as default language if no language is set
export const language = localStorage.getItem("language") || "ar";
if (!localStorage.getItem("language")) {
  localStorage.setItem("language", "ar");
}
